const AttachmentsItemModel = {};

export default AttachmentsItemModel;
